import React from 'react';
import styled from 'styled-components/macro';
import { Heading1 } from '../../../../typography';
import { LiterFormat, VolumePrUnit } from '../../../../Format';

const Heading = styled(Heading1)`
  text-transform: capitalize;
`;

const RenderNameHeading = ({
  heading,
  name,
  countPrColli,
  liter,
  productTypePack,
  productTypeGlass,
  productTypeReservedel,
  productTypeFadoel,
}) => {
  if (heading) {
    return (
      <React.Fragment>
        <Heading>{heading}</Heading>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <Heading>{name}{!productTypePack && !productTypeGlass && !productTypeReservedel && !productTypeFadoel && (<React.Fragment> {countPrColli}x<VolumePrUnit liter={liter} amount={countPrColli} /></React.Fragment>)}{productTypeFadoel && (<React.Fragment> <LiterFormat liter={liter} noSuffix />l</React.Fragment>)}</Heading>
    </React.Fragment>
  );
};

// Export Default
export default RenderNameHeading;
